// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { getCountry, getSafePaymentType, getSafeVoucherUrl, usePendingIncomingPayment, getRedirectUrl } from '@tectonics/prs/incoming-payment';
import { useRedirect } from '@tectonics/hooks';
import type { PendingIncomingPayment } from '@tectonics/prs/incoming-payment';
import { Separator, Link } from '../../../../commons/atoms';

export function RedirectPage(): Node {
  const incomingPayment = usePendingIncomingPayment();
  const redirectUrl = getRedirectUrlByIncomingPayment(incomingPayment);

  useRedirect(redirectUrl, 1000);

  return (
    <Root>
      <Separator size={4} />
      <LabelMessage redirectUrl={redirectUrl} />
    </Root>
  );
}

const Root = styled.div`
  height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
`;

type LabelMessageProps = {|
  +redirectUrl: string,
|};

function LabelMessage({ redirectUrl }: LabelMessageProps): Node {
  const incomingPayment = usePendingIncomingPayment();
  const country = getCountry(incomingPayment);

  switch (country) {
    case 'br':
      return <p>Você está sendo redirecionado para as instruções de pagamento, se isso não acontecer, <Link href={redirectUrl}>clique aqui</Link>.</p>;
    case 'cl':
    case 'ar':
    case 'uy':
    case 'co':
    case 'ec':
    case 'pe':
      return <p>Usted está siendo redirigido, si esto no sucede, <Link href={redirectUrl}>haga clic aquí</Link>.</p>;

    default:
      throw new Error(`No redirect-page-content found for country ${country}`);
  }
}

function getRedirectUrlByIncomingPayment(incomingPayment: PendingIncomingPayment): string {
  const paymentType = getSafePaymentType(incomingPayment);

  switch (paymentType) {
    case 'banktransfer':
      return getSafeVoucherUrl(incomingPayment);
    case 'eft':
    case 'multicaja':
    case 'safetypay-cash':
    case 'safetypay-online':
    case 'safetypay':
    case 'sencillito':
    case 'servipag':
    case 'webpay':
    case 'ewallet':
    case 'externalpayprovider':
      return getRedirectUrl(incomingPayment);
    default:
      throw new Error(`No redirect-page-content found for payment_type ${paymentType}`);
  }
}
